export default "__VITE_ASSET__BuBxpWIb__"